<p-sidebar
  [(visible)]="sidebarVisible"
  position="right"
  [transitionOptions]="'.3s cubic-bezier(0, 0, 0.2, 1)'"
  styleClass="layout-profile-sidebar w-full sm:w-25rem"
  [showCloseIcon]="false"
  [modal]="showFocus"
  (onHide)="closeSidebar()"
>
  <ng-template pTemplate="header">
    <div class="custom-sidebar-content flex align-items-center justify-content-between">
      <p-button
        class="back-button flex-1"
        icon="pi pi-arrow-left"
        [rounded]="true"
        [text]="true"
        [raised]="true"
        (click)="closeSidebar()"
      />
      <div class="title flex-auto text-center">{{ title }}</div>
      <p-button
        class="times-button flex-1 flex justify-content-end"
        icon="pi pi-times"
        [rounded]="true"
        [text]="true"
        severity="secondary"
        (click)="closeSidebar()"
      />
    </div>
  </ng-template>
  <ng-content></ng-content>
</p-sidebar>
